import { Component } from '@angular/core';

@Component({
  selector: 'vb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false  //NOSONAR
})
export class FooterComponent {}
